import React, { createContext, useEffect, useState } from 'react';
import { FullPageLoader } from 'src/components';
import { getValue, urlQueryParams } from 'src/helpers/custom-url-search-param';

export const QueryConfigContext = createContext();

export function QueryConfigProvider({
  children,
  sessionStorageKey = 'query-config',
  readQueryStringOnce = true, // set to true if query params only read once on initial page load
}) {
  const [queryString, setQueryString] = useState('');
  const [queryConfig, setQueryConfig] = useState(null);
  const [sessionStorageLoaded, setSessionStorageLoaded] = useState(false);
  const [queryConfigReady, setQueryConfigReady] = useState(false);

  if (window.location.search && queryString !== window.location.search) {
    setQueryString(window.location.search);
  }

  useEffect(() => {
    const queryParamsString = sessionStorage.getItem(sessionStorageKey);
    if (queryParamsString) {
      setQueryConfig(JSON.parse(queryParamsString));
    }
    setSessionStorageLoaded(true);
  }, []);

  useEffect(() => {
    if (sessionStorageLoaded) {
      // This needs to be tested with the new method.
      const entries = urlQueryParams(queryString);
      let queryParams = {};
      Object.keys(entries).forEach((key) => (queryParams[key] = getValue(entries, key)));

      const isQueryConfigOutOfDate =
        !queryConfig ||
        Object.keys(queryParams).every((key) => queryParams[key] !== queryConfig[key]);

      if (queryConfig && readQueryStringOnce) {
        setQueryConfigReady(true);
        return;
      }

      if (isQueryConfigOutOfDate) {
        setQueryConfig((queryConfigCurrent) => {
          const queryConfigNew = {
            ...queryConfigCurrent,
            ...queryParams,
          };
          sessionStorage.setItem(sessionStorageKey, JSON.stringify(queryConfigNew));

          return queryConfigNew;
        });
      }

      setQueryConfigReady(true);
    }
  }, [queryString, sessionStorageLoaded]);

  return queryConfigReady ? (
    <QueryConfigContext.Provider value={{ queryConfig }}>{children}</QueryConfigContext.Provider>
  ) : (
    <FullPageLoader showLoader={true} />
  );
}
